import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import DOMPurify from "dompurify";

import ThemeImg from "../../img/theme-img.webp";
import SiteDecor from "../../img/site-decor.webp"


const Themes = ({ themesData }) => {
    if (!themesData) return null;

    const { theme_title, theme_subtitle, theme_list } = themesData;

    const ThemeIcon = () => (
        <svg width="14" height="12" viewBox="0 0 14 12" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.3324 9.95398L10.9466 6.30211L0.819276 6.30211C-0.27252 6.30211 -0.27252 4.60795 0.819276 4.60795L10.796 4.60795L7.18181 1.18197C6.54179 0.617245 7.52064 -0.399254 8.16066 0.165468L13.3561 5.09737C13.5443 5.28561 13.582 5.66209 13.3561 5.85033L8.3489 10.9328C7.74653 11.5352 6.69238 10.5563 7.3324 9.95398Z"
                fill="black"
            />
        </svg>
    );


    return (
        <section className="relative mb-16 md:mb-32 py-14 bg-[linear-gradient(280deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]
            lg:py-[120px] overflow-hidden">
            <div className="container max-w-screen-xl mx-auto px-[15px] ">

                <div className="md:flex md:gap-7 md:items-stretch xl:gap-16 z-10 relative">

                    <div>
                        <img src={ThemeImg} className="hidden md:block h-full w-full object-cover" alt="img BWS" />
                    </div>

                    <div>
                        <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                            <h2 className="text-3xl text-white text-center font-bold uppercase mb-9 md:text-left
                            lg:text-[42px] lg:mb-12 xl:text-[52px]">У програмі:</h2>
                        </ScrollAnimation>

                        <div className="h-96 mb-9 md:hidden"><img src={ThemeImg} className="h-full w-full object-cover" alt="img BWS" /></div>

                        <div>
                            <ul className="mb-8 lg:mb-10">
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <li className="relative text-white font-bold text-lg border-b-[1px] border-t-[1px] border-white
                                    py-4 pl-12 pr-3 lg:pl-[10%] lg:text-2xl lg:py-7">
                                    <span className="w-7 h-7 bg-white flex items-center justify-center rounded-full absolute top-5 left-0
                                        lg:w-10 lg:h-10 lg:top-7"><ThemeIcon /></span>
                                    Кейси з галузей реального сектору економіки</li>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <li className="relative text-white font-bold text-lg border-b-[1px] border-white
                                    py-4 pl-12 pr-3 lg:pl-[10%] lg:text-2xl lg:py-7">
                                    <span className="w-7 h-7 bg-white flex items-center justify-center rounded-full absolute top-5 left-0
                                        lg:w-10 lg:h-10 lg:top-7"><ThemeIcon /></span>
                                    Практичні інсайти від CEO та засновників компаній, що стали ядром нової української економіки</li>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <li className="relative text-white font-bold text-lg border-b-[1px] border-white
                                    py-4 pl-12 pr-3 lg:pl-[10%] lg:text-2xl lg:py-7">
                                    <span className="w-7 h-7 bg-white flex items-center justify-center rounded-full absolute top-5 left-0
                                        lg:w-10 lg:h-10 lg:top-7"><ThemeIcon /></span>
                                    Рекомендації експертів щодо фінансової стійкості та захисту бізнесу в умовах війни й нестабільності</li>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <li className="relative text-white font-bold text-lg border-b-[1px] border-white
                                    py-4 pl-12 pr-3 lg:pl-[10%] lg:text-2xl lg:py-7">
                                    <span className="w-7 h-7 bg-white flex items-center justify-center rounded-full absolute top-5 left-0
                                        lg:w-10 lg:h-10 lg:top-7"><ThemeIcon /></span>
                                    Панельні дискусії за участі представників уряду та великого бізнесу</li>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>   
                                    <li className="relative text-white font-bold text-lg border-b-[1px] border-white
                                    py-4 pl-12 pr-3 lg:pl-[10%] lg:text-2xl lg:py-7">
                                    <span className="w-7 h-7 bg-white flex items-center justify-center rounded-full absolute top-5 left-0
                                        lg:w-10 lg:h-10 lg:top-7"><ThemeIcon /></span>
                                    Нетворкінг з управлінцями, які трансформують український бізнес</li>
                                </ScrollAnimation>
                            </ul>
                            <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                                <p className="uppercase text-white text-xl xl:text-2xl">Business Wisdom Summit 2026 — платформа для тих, хто не пристосовується до реальності, а формує її</p>
                            </ScrollAnimation>
                        </div>
                    </div>

                </div>

            </div>

            
            <div className="absolute top-20 -right-12 w-52 md:-top-[18%] md:-right-20 w-[450px]">
                <img src={SiteDecor} alt="decor" className="w-full"/>
            </div>

            <div className="absolute -left-1/4 -bottom-1/4 hidden md:block w-1/2">
                <img src={SiteDecor} alt="decor" className="w-full"/>
            </div>

            
        </section>
    )
}

export default Themes;